import { SimpleFormCheck } from "../form/SimpleFormCheck";
import { Col, Row } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { LangType } from "src/app/types/LangType";
import { toAbsoluteUrl } from "src/app/utils/AssetHelpers";

export interface ISimpleLangCheck {
    name?: string;
    cssClass?: string[];
}
const SimpleLangCheck = (props: ISimpleLangCheck) => {
    const { name = "lang", cssClass = ["mb-0"] } = props;
    const langs = Object.keys(LangType);

    return (
        <Row>
            {langs.map((lang, index) => (
                <Col key={index} className="mb-2 col-sm-4">
                    <label htmlFor={`lang${index}`} className="hover-outline" key={index}>
                        <SimpleFormCheck
                            index={index}
                            name={name}
                            type="radio"
                            cssClass={cssClass}
                            value={lang}
                            label={
                                <SVG
                                    width={16}
                                    src={toAbsoluteUrl(`/media/flags/${lang.toLowerCase()}.svg`)}
                                />
                            }
                        />
                    </label>
                </Col>
            ))}
        </Row>
    );
};

export default SimpleLangCheck;
